import { Component, Input } from '@angular/core';
import {
  BASE_INQUIRY_CALENDAR_DAY_COLUMN_WIDTH,
  SimilarInquiriesDateInterface,
  ShiftPlanListBubbleItemInterface,
} from 'base';

@Component({
  selector: 'base-customer-similar-inquiries-dates',
  templateUrl: './base-similar-inquiries-dates-list.component.html',
})
export class BaseSimilarInquiriesDatesListComponent {
  @Input() similarInquiriesDays: SimilarInquiriesDateInterface[];

  dayColumnWidth = BASE_INQUIRY_CALENDAR_DAY_COLUMN_WIDTH;

  trackByDay(_: number, item: SimilarInquiriesDateInterface) {
    return item.date;
  }

  trackByBubble(_: number, item: ShiftPlanListBubbleItemInterface) {
    return item.shift;
  }
}
